import type { CdaObservationMedia } from '@ctw/shared/utils/cda/types';
import { createContext, memo, type PropsWithChildren, useContext } from 'react';

type ObservationMediaById = Record<string, CdaObservationMedia>;

const ObservationMediaContext = createContext<ObservationMediaById | undefined>(undefined);

interface ObservationMediaProviderProps extends PropsWithChildren {
  observationMediaById: ObservationMediaById;
}

export const ObservationMediaProvider = memo(
  ({ observationMediaById, children }: ObservationMediaProviderProps) => (
    <ObservationMediaContext.Provider value={observationMediaById}>
      {children}
    </ObservationMediaContext.Provider>
  ),
);

// Falls back to `{}` instead of throwing — unlike `useCdaSectionSelectionContext`/
// `useDocumentViewerContext`, a missing provider here has a well-defined meaning (no known
// `observationMedia` entries, so every `renderMultiMedia` reference is unresolved) rather than
// being a wiring mistake, and this keeps every node-renderer test that doesn't care about
// multimedia unaffected.
export const useObservationMediaById = (): ObservationMediaById =>
  useContext(ObservationMediaContext) ?? {};
